webpackJsonp([1],{

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(310)

var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(317),
  /* scopeId */
  "data-v-2e1ce80b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(114);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(72);

var _config = __webpack_require__(28);

var _com = __webpack_require__(9);

__webpack_require__(308);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var playerBar = function playerBar() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 314));
};

exports.default = {
  data: function data() {
    return {
      editForm: {
        done: false,
        mediaurl: '',
        loading: false
      },
      id: null,
      index: null,
      urladdr: './review'
    };
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    newContent: 'newContent',
    pressdata: 'pressdata',
    presstotal: 'presstotal',
    'getOsspolicy': 'getOsspolicy',
    'getOsskeyid': 'getOsskeyid',
    'getOsssign': 'getOsssign'
  }), {
    formatCategory: function formatCategory() {
      return _config.newsType[this.newContent.category] || '';
    },
    formatLabels: function formatLabels() {
      return this.newContent.labels.split('#') || [];
    },
    formatLabels2: function formatLabels2() {
      return this.newContent.labels.split('#').join(' / ') || '';
    },
    formatHotIndex: function formatHotIndex() {
      return _config.hotsType[this.newContent.hotindex + ''];
    },
    formatSourcefrom: function formatSourcefrom() {
      return this.newContent.sourcefrom || '';
    },
    formatMedia: function formatMedia() {
      return this.newContent.mediaurl || '';
    },
    preNewsId: function preNewsId() {
      if (this.pressdata.length && this.pressdata.length > 0 && this.index > 0) {
        console.debug("preNewsId> index:%o, pre:%o", this.index, this.index - 1);
        return this.index - 1;
      } else {
        console.debug("preNewsId> -1");
        return -1;
      }
    },
    nextNewsId: function nextNewsId() {
      if (this.pressdata.length && this.pressdata.length > 0 && this.index < this.pressdata.length - 1) {
        console.debug("nextNewsId> index:%o, next:%o", this.index, this.index + 1);
        return this.index + 1;
      } else {
        console.debug("nextNewsId> -1");
        return -1;
      }
    }
  }),
  created: function created() {
    this.id = this.$route.query.id || '';
    var index = this.$route.query.index || 0;
    this.index = parseInt(index);
    console.debug("created> id:%o, index:%o, pressdata:%o, statstotal:%o", this.id, this.index, this.pressdata, this.presstotal);
    var item = this.reqNewsContent(this.id, this.pressdata);
    console.debug("created> item:%o", item);
    this.updateNewsContent(item);

    console.debug("created> editForm:%o", this.editForm);
  },

  watch: {
    '$route': function $route(to, from) {
      console.debug("watch>route start to:%o, from:%o", to, from);
      console.debug("watch route> id:%o, index:%o, pressdata:%o, presstotal:%o", this.id, this.index, this.pressdata, this.presstotal);

      this.id = this.$route.query.id || '';
      var index = this.$route.query.index || 0;
      this.index = parseInt(index);
      console.debug("created> id:%o, index:%o, pressdata:%o, presstotal:%o", this.id, this.index, this.pressdata, this.presstotal);
      var item = this.reqNewsContent(this.id, this.pressdata);
      console.debug("route> item:%o", item);
      this.updateNewsContent(item);
    }
  },
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
    editNewsContent: 'editNewsContent',
    transferNewsState: 'transferNewsState',
    updateNewsContent: 'updateNewsContent'
  }), {
    reqNewsContent: function reqNewsContent(id, datalist) {
      console.debug('reqNewsContent> id:%o, datalist:%o', id, datalist);
      var data = null;
      var hasUser = datalist.some(function (u) {
        if (u.id === id) {
          data = JSON.parse((0, _stringify2.default)(u));
          return true;
        }
      });
      console.debug("reqNewsContent> hasUser:%o, data:%o", hasUser, data);
      return data;
    }
  }),
  components: {
    playerBar: playerBar
  }
};

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(273)();
// imports


// module
exports.push([module.i, "#pressreview .el-item.item-2x{padding:20px;box-sizing:border-box;min-height:195px}#pressreview .el-tag{padding:0 12px;margin:0 5px}#pressreview .el-progress-bar__outer{border-radius:4px}#pressreview .el-progress-bar__inner{border-radius:0}#pressreview .el-progress.is-success .el-progress-bar__inner{background:#b9d963}#pressreview .month-turnover{padding:10px 15px;border-radius:5px;margin-top:28px}#pressreview .news-box{padding:10px 15px;display:flex;flex-direction:column;justify-content:flex-start}#pressreview .news-box .box-header{display:inline-flex;flex-direction:row;justify-content:space-between}#pressreview .news-box .box-header .new-type{color:#58b7ff;font-weight:700}#pressreview .news-box .box-header .hot-level{color:#d22953;font-weight:700}#pressreview .news-box .box-title{margin:10px 0}#pressreview .news-box .box-content .box-origin,#pressreview .news-box .box-content .box-source,#pressreview .news-box .box-content .box-text{padding:10px 0}#pressreview .news-box .box-foot{display:inline-flex;flex-direction:row;justify-content:flex-end;color:#939393;text-align:right}#pressreview .news-box .pre-next-page{color:#475669;margin:10px 0}#pressreview .news-box .pre-next-page .page-text{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", "", {"version":3,"sources":["D:/project/lipan82-atlanta.jizhuoyangqing.com/src/static/style/press/D:\\project\\lipan82-atlanta.jizhuoyangqing.com/src\\static\\style\\press\\review.scss"],"names":[],"mappings":"AAAA,8BAEQ,aAAa,AACb,sBAAsB,AACtB,gBAAiB,CACpB,AALL,qBAUQ,eAAe,AACf,YACJ,CAAE,AAZN,qCAcQ,iBAAkB,CACrB,AAfL,qCAiBQ,eAAgB,CACnB,AAlBL,6DAoBQ,kBAAmB,CACtB,AArBL,6BAuBQ,kBAAkB,AAClB,kBAAkB,AAClB,eAAgB,CACnB,AA1BL,uBA6BQ,kBAAkB,AAElB,aAAa,AACb,sBAAsB,AACtB,0BAA2B,CA4D9B,AA7FL,mCAoCY,oBAAoB,AACpB,mBAAmB,AACnB,6BAA8B,CAUjC,AAhDT,6CAwCgB,cAAc,AACd,eAAiB,CACpB,AA1Cb,8CA4CgB,cAAc,AACd,eAAiB,CACpB,AA9Cb,kCAkDY,aAAc,CACjB,AAnDT,8IAoEY,cAAe,CAChB,AArEX,iCAyEY,oBAAoB,AACpB,mBAAmB,AACnB,yBAAyB,AACzB,cAAc,AAEd,gBAAiB,CACpB,AA/ET,sCAoFY,cAAc,AACd,aAAc,CAOjB,AA5FT,iDAwFgB,gBAAgB,AAChB,mBAAmB,AACnB,sBAAuB,CAC1B","file":"review.scss","sourcesContent":["#pressreview {\r\n    .el-item.item-2x {\r\n        padding: 20px;\r\n        box-sizing: border-box;\r\n        min-height: 195px;\r\n    }\r\n    .el-row {\r\n        //margin-bottom: 15px;\r\n    }\r\n    .el-tag {\r\n        padding: 0 12px;\r\n        margin: 0 5px\r\n    }\r\n    .el-progress-bar__outer {\r\n        border-radius: 4px;\r\n    }\r\n    .el-progress-bar__inner {\r\n        border-radius: 0;\r\n    }\r\n    .el-progress.is-success .el-progress-bar__inner {\r\n        background: #B9D963;\r\n    }\r\n    .month-turnover {\r\n        padding: 10px 15px;\r\n        border-radius: 5px;\r\n        margin-top: 28px;\r\n    }\r\n\r\n    .news-box{\r\n        padding: 10px 15px;\r\n\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: flex-start;\r\n\r\n        .box-header{\r\n            display: inline-flex;\r\n            flex-direction: row;\r\n            justify-content: space-between;\r\n            .new-type{\r\n                color: #58B7FF;\r\n                font-weight: bold;\r\n            }\r\n            .hot-level{\r\n                color: #d22953;\r\n                font-weight: bold;\r\n            }\r\n\r\n        }\r\n        .box-title{\r\n            margin: 10px 0;\r\n        }\r\n        .box-content{\r\n          /*display: inline-flex;\r\n          flex-direction: column;\r\n          justify-content: space-between;\r\n          align-items: flex-start;*/\r\n          .box-image{\r\n            //max-width: 40%;\r\n            //margin: 0 auto;\r\n          }\r\n          .box-text{\r\n            padding: 10px 0;\r\n          }\r\n          .box-source{\r\n            padding: 10px 0;\r\n          }\r\n          .box-origin{\r\n            padding: 10px 0;\r\n          }\r\n\r\n        }\r\n        .box-foot{\r\n            display: inline-flex;\r\n            flex-direction: row;\r\n            justify-content: flex-end;\r\n            color: #939393;\r\n            /*font-size: 8px;*/\r\n            text-align: right;\r\n        }\r\n        .pre-next-page {\r\n            /*display: inline-flex;\r\n            flex-direction: row;\r\n            justify-content: space-between;*/\r\n            color: #475669;\r\n            margin: 10px 0;\r\n            .page-text {\r\n                //width: 300px;\r\n                overflow: hidden;\r\n                white-space: nowrap;\r\n                text-overflow: ellipsis;\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(273)();
// imports


// module
exports.push([module.i, ".editor-btn[data-v-2e1ce80b]{margin-top:20px}.header[data-v-2e1ce80b]{background:#fff;border-top:none;border-left:none;border-right:none;position:fixed;z-index:1;width:100%;height:3.6rem;border:1px solid #939393;border-style:none none solid}.header .header-tips[data-v-2e1ce80b]{display:inline-flex;flex-direction:row;justify-content:flex-start}.header .header-tips .header-tips-audio[data-v-2e1ce80b]{width:500px}.header .header-btn[data-v-2e1ce80b]{width:180px;display:inline-flex;flex-direction:row;justify-content:space-between}.editor-content[data-v-2e1ce80b]{padding:3.6rem .8rem;background:#fff}.input-new-tag[data-v-2e1ce80b]{width:120px}.box-author[data-v-2e1ce80b]{color:#939393;margin-bottom:14px}.avatar-uploader .el-upload[data-v-2e1ce80b]{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload[data-v-2e1ce80b]:hover{border-color:#20a0ff}.avatar-uploader-icon[data-v-2e1ce80b]{color:#8c939d;width:178px;height:178px;line-height:178px;text-align:center}.avatar[data-v-2e1ce80b]{width:178px;height:178px;display:block}", "", {"version":3,"sources":["D:/project/lipan82-atlanta.jizhuoyangqing.com/src/components/press/review.vue"],"names":[],"mappings":"AACA,6BACI,eAAiB,CACpB,AACD,yBACI,gBAAkB,AAGlB,gBAAiB,AACjB,iBAAkB,AAClB,kBAAmB,AAKnB,eAAgB,AAChB,UAAW,AACX,WAAY,AACZ,cAAe,AACf,yBAA0B,AAC1B,4BAAmC,CACtC,AACD,sCAKE,oBAAqB,AACrB,mBAAoB,AACpB,0BAA4B,CAC7B,AACD,yDAEE,WAAa,CACd,AACD,qCAEE,YAAa,AACb,oBAAqB,AACrB,mBAAoB,AACpB,6BAA+B,CAChC,AACD,iCAKE,qBAAsB,AACtB,eAAkB,CACnB,AACD,gCACE,WAAa,CACd,AACD,6BAEE,cAAe,AACf,kBAAoB,CACrB,AACD,6CACE,0BAA2B,AAC3B,kBAAmB,AACnB,eAAgB,AAChB,kBAAmB,AACnB,eAAiB,CAClB,AACD,mDACE,oBAAsB,CACvB,AACD,uCAEE,cAAe,AACf,YAAa,AACb,aAAc,AACd,kBAAmB,AACnB,iBAAmB,CACpB,AACD,yBACE,YAAa,AACb,aAAc,AACd,aAAe,CAChB","file":"review.vue","sourcesContent":["\n.editor-btn[data-v-2e1ce80b]{\n    margin-top: 20px;\n}\n.header[data-v-2e1ce80b]{\n    background: white;\n    /*padding: 0 20%;\n    height: 50px;*/\n    border-top: none;\n    border-left: none;\n    border-right: none;\n    /*display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;*/\n    position: fixed;\n    z-index: 1;\n    width: 100%;\n    height: 3.6rem;\n    border: 1px solid #939393;\n    border-style: none none solid none;\n}\n.header .header-tips[data-v-2e1ce80b]{\n  /*font-size: 10px;\n  color: #939393;*/\n  /*width: 80%;*/\n  /*border: 1px solid black;*/\n  display: inline-flex;\n  flex-direction: row;\n  justify-content: flex-start;\n}\n.header .header-tips .header-tips-audio[data-v-2e1ce80b]{\n  /*border: 1px solid blue;*/\n  width: 500px;\n}\n.header .header-btn[data-v-2e1ce80b]{\n  /*border: 1px solid black;*/\n  width: 180px;\n  display: inline-flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.editor-content[data-v-2e1ce80b]{\n  /*border: 1px solid blue;*/\n  /*margin: 0 auto;*/\n  /*width: 60%;*/\n  /*height: 600px;*/\n  padding: 3.6rem .8rem;\n  background: white;\n}\n.input-new-tag[data-v-2e1ce80b]{\n  width: 120px;\n}\n.box-author[data-v-2e1ce80b]{\n  /*font-size: 10px;*/\n  color: #939393;\n  margin-bottom: 14px;\n}\n.avatar-uploader .el-upload[data-v-2e1ce80b] {\n  border: 1px dashed #d9d9d9;\n  border-radius: 6px;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n}\n.avatar-uploader .el-upload[data-v-2e1ce80b]:hover {\n  border-color: #20a0ff;\n}\n.avatar-uploader-icon[data-v-2e1ce80b] {\n  /*font-size: 28px;*/\n  color: #8c939d;\n  width: 178px;\n  height: 178px;\n  line-height: 178px;\n  text-align: center;\n}\n.avatar[data-v-2e1ce80b] {\n  width: 178px;\n  height: 178px;\n  display: block;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(301);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(274)("610fb3fc", content, true);

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(303);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(274)("3e31d5fe", content, true);

/***/ }),

/***/ 317:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pressreview"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('el-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle",
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "header-tips",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [(_vm.newContent.mediaurl) ? _c('audio', {
    staticClass: "header-tips-audio",
    attrs: {
      "src": _vm.newContent.mediaurl,
      "controls": "controls",
      "controlsList": "nodownload",
      "oncontextmenu": "return false"
    }
  }, [_vm._v("\n        您的浏览器不支持 audio 标签。\n        ")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [_c('div', {
    staticClass: "editor-content"
  }, [_c('div', {
    staticClass: "news-box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('span', {
    staticClass: "new-type fs-label"
  }, [_vm._v(_vm._s(_vm.formatCategory))]), _vm._v(" "), _c('span', {
    staticClass: "hot-level fs-label"
  }, [_vm._v(_vm._s(_vm.formatHotIndex))])]), _vm._v(" "), _c('div', {
    staticClass: "box-title"
  }, [_c('h1', {
    staticClass: "fs-title"
  }, [_vm._v(_vm._s(_vm.newContent.title))])]), _vm._v(" "), _c('div', {
    staticClass: "box-author fs-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.newContent.date) + " ")]), _vm._v(" "), (_vm.newContent.editorname) ? _c('span', [_vm._v(" 编:" + _vm._s(_vm.newContent.editorname))]) : _vm._e(), _vm._v(" "), (_vm.newContent.hostname) ? _c('span', [_vm._v(" 播:" + _vm._s(_vm.newContent.hostname))]) : (_vm.newContent.host) ? _c('span', [_vm._v(" 播:" + _vm._s(_vm.newContent.host))]) : _vm._e(), _vm._v(" "), (_vm.newContent.verifiername) ? _c('span', [_vm._v(" 审:" + _vm._s(_vm.newContent.verifiername))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-content"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 20,
      "sm": 20,
      "md": 12,
      "lg": 10
    }
  }, [_c('img', {
    staticClass: "box-image",
    attrs: {
      "src": _vm.newContent.cover
    }
  })])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('p', {
    staticClass: "box-text fs-text"
  }, [_vm._v(_vm._s(_vm.newContent.content))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box-source fs-text"
  }, [_c('span', [_vm._v("新闻来源:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatSourcefrom))])]), _vm._v(" "), _c('div', {
    staticClass: "box-origin fs-text"
  }, [_c('span', [_vm._v("原文地址:")]), _c('a', {
    attrs: {
      "href": _vm.newContent.sourceurl,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "link-url"
  }, [_vm._v(_vm._s(_vm.newContent.sourceurl))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-foot fs-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.formatLabels2))])]), _vm._v(" "), _c('el-row', {
    staticClass: "pre-next-page",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('div', [(_vm.preNewsId !== -1) ? _c('router-link', {
    attrs: {
      "to": {
        path: _vm.urladdr,
        query: {
          id: _vm.pressdata[_vm.preNewsId].id,
          index: _vm.preNewsId
        }
      }
    }
  }, [_c('p', {
    staticClass: "page-text fs-label"
  }, [_vm._v("上一篇 " + _vm._s(_vm.pressdata[_vm.preNewsId].title))])]) : _vm._e()], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('div', [(_vm.nextNewsId !== -1) ? _c('router-link', {
    attrs: {
      "to": {
        path: _vm.urladdr,
        query: {
          id: _vm.pressdata[_vm.nextNewsId].id,
          index: _vm.nextNewsId
        }
      }
    }
  }, [_c('p', {
    staticClass: "page-text fs-label"
  }, [_vm._v("下一篇 " + _vm._s(_vm.pressdata[_vm.nextNewsId].title))])]) : _vm._e()], 1)])], 1)], 1)])])], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.db11dd995d2454b63341.js